var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flix-form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("design.color.title"))+" "),_c('help',[_vm._v(_vm._s(_vm.$t("design.color.info")))])],1),_c('colorPicker',{attrs:{"value":_vm.color,"callback":_vm.setColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }